export const COLOR_BLEU_EM = '#22286d';
export const COLOR_ROSE = '#e0055a';
export const COLOR_VERT = '#bed62f';
export const COLOR_BLEU = '#14b0e6';
export const COLOR_JAUNE = '#fdb813';
export const COLOR_ORANGE = '#e95a0c';
export const COLOR_ROUGE = '#c10000';
export const COLOR_GRIS_1 = '#abafb1';
export const COLOR_GRIS_2 = '#d6d6d6';
export const COLOR_GRIS_3 = '#cccccc';
export const COLOR_GRIS_4 = '#ececec';
export const COLOR_GRIS_5 = '#7c7c7c';
export const COLOR_GRIS_6 = '#919191';
export const COLOR_GRIS_FOND = '#f5f5f5 ';
export const COLOR_GRIS_DISABLED = '#eaeaea ';
export const COLOR_BLANC = '#fff';
export const COLOR_PROMO = '#13ac42';
export const COLOR_GREEN_PRIME = '#5eb67c';
